"use strict";
// @flow
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginRequest = exports.msalConfig = exports.getAzureTokens = exports.Session = void 0;
// vendors
const framework_1 = require("../../framework");
const config_1 = require("./config");
Object.defineProperty(exports, "msalConfig", { enumerable: true, get: function () { return config_1.msalConfig; } });
Object.defineProperty(exports, "loginRequest", { enumerable: true, get: function () { return config_1.loginRequest; } });
class Session extends framework_1.AzureSession {
    constructor(store) {
        super(store);
    }
    doRefresh() {
        throw new Error('Error while creating session');
    }
}
exports.Session = Session;
const getAzureTokens = (store) => __awaiter(void 0, void 0, void 0, function* () {
    const session = new Session(store);
    const azureAdInitialized = new framework_1.AzureAd(session, config_1.msalConfig);
    yield azureAdInitialized.login(config_1.loginRequest);
    const data = session.getData();
    return (data && {
        accessToken: data.accessToken,
        refreshToken: data.refreshToken,
    });
});
exports.getAzureTokens = getAzureTokens;
//# sourceMappingURL=azureCommons.js.map